module.exports = __webpack_public_path__ + "static/media/ic_variable.15c23941.svg";